import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { Alert, Button, message } from "antd"
import printImage from "../../../helpers/printQRCode/printImage"
import drawLabel from "../../../helpers/printQRCode/drawLabel"
import { saveHistory, markCompletedByOrderIdV2 } from "../../../services/api/3dApi"
import addItemToBasket from "../actions/addItemToBasket"
import { Modal } from 'antd'

class ExportQrCode extends Component {
    state = {
        loading: false,
        error: '',
        brandingItemPending: []
    }

    componentDidMount() {

    }

    _parseInfo = (info, basket, totalItems) => {
        const regex = /([0-9]{5,}_)([0-9]+)/
        const parsed = info.barcode.match(regex)

        if (parsed) {
            return {
                orderId: `#${info.barcode}`,
                type: info.product_type,
                basket: basket,
                total: totalItems,
                size: info.product_size,
            }
        }
    }

    _handleClickPrintQR = (item, itemIndex) => async (e) => {
        e.preventDefault()

        const { basket, totalItems, reset, errorTypeMessage, items = [] } = this.props
        const GIFTBOX_0700NO = items.length > 0 ? items.filter(item => ['GIFTBOX_0700NO'].includes(item.product_type)) : []
        const GIFTCARD_1800NO = items.length > 0 ? items.filter(item => ['GIFTCARD_1800NO'].includes(item.product_type)) : []
        const BOX_0700NO = items.length > 0 ? items.filter(item => ['BOX_0700NO'].includes(item.product_type)) : []
        const THANK_CARD = items.length > 0 ? items.filter(item => ['THANK_CARD', 'BRAND_KIT'].includes(item.product_type)) : []

        this.setState({
            [`loading_${itemIndex}`]: true,
            error: ''
        })

        try {
            const { data: response } = await saveHistory(item.barcode)
            const { success, message, error: errMsg } = response

            if (!success) {
                if (errorTypeMessage) {
                    this.setState({
                        [`loading_${itemIndex}`]: false,
                    })
                    Modal.error({
                        title: 'Lỗi',
                        content: message || errMsg,
                        okText: 'Đóng',
                    })
                } else {
                    this.setState({
                        [`loading_${itemIndex}`]: false,
                        error: message || errMsg
                    })
                }
                return
            }

            this.setState({
                [`loading_${itemIndex}`]: false,
                error: ''
            }, () => {
                drawLabel(this._parseInfo(item, basket, totalItems)).then(r => printImage(r))
                if (!!reset) {
                    if (!GIFTBOX_0700NO.length && !GIFTCARD_1800NO.length && !BOX_0700NO.length && !THANK_CARD.length) {
                        reset()
                    }
                }
            })
        } catch (err) {
            if (errorTypeMessage) {
                this.setState({
                    [`loading_${itemIndex}`]: false,
                })
                Modal.error({
                    title: 'Lỗi',
                    content: err.message,
                    okText: 'Đóng',
                })
            } else {
                this.setState({
                    [`loading_${itemIndex}`]: false,
                    error: err.message
                })
            }
        }
    }

    _handleQc = async (_id, barcode) => {
        try {
            if (!_id) return

            const payload = {
                order_ids: [_id]
            }

            const { data: response } = await markCompletedByOrderIdV2(payload)
            const { success, data, error } = response

            if (!success) throw new Error(error)

            const { failedOrders = [] } = data

            if (!!failedOrders.length) {
                const { message: messError } = !!failedOrders[0] ? failedOrders[0] : {}
                return message.error(messError)
            }

            message.success(`Item #${barcode} đã được đánh dấu QC hoàn thành.`)
            if (barcode) {
                const { onSetData, reload, containerRef } = this.props
                if (typeof onSetData === 'function') {
                    const dataBasket = await addItemToBasket(barcode, '1C', containerRef)
                    onSetData(dataBasket)
                } else {
                    reload()
                }
            }

        } catch (error) {
            message.error(error.message)
        }
    }

    render() {
        const { error, loading } = this.state
        const { items = [], className, isShowButtonQC } = { ...this.props }
        const brandingItemPending = items.length > 0 ? items.filter(item => ['THANK_CARD', 'BRAND_KIT', 'GIFTCARD_1800NO'].includes(item.product_type)) : []
        // const otherItemsCompleted = items.length > 0 ? items.filter(item => !['THANK_CARD', 'BRAND_KIT'].includes(item.product_type) && item.status === 'completed') : []
        // const isCompletedAllOtherItems = otherItemsCompleted.length === items.length - brandingItemPending.length
        const GIFTBOX_0700NO = items.length > 0 ? items.filter(item => ['GIFTBOX_0700NO'].includes(item.product_type)) : []
        const BOX_0700NO = items.length > 0 ? items.filter(item => ['BOX_0700NO'].includes(item.product_type)) : []
        // const completeExceptGIFTBOX_0700NO = items.length > 0 ? items.filter(item => !['GIFTBOX_0700NO'].includes(item.product_type) && item.status === 'completed') : []

        return <>
            {brandingItemPending.length > 0 &&
                brandingItemPending.map((item, itemIndex) => {
                    const { orderData = {}, barcode = '' } = { ...item }
                    const { batchItem = {} } = { ...orderData }
                    const [_, numberIndex] = `${item.barcode}`.split('_')
                    const {
                        [`loading_${itemIndex}`]: loading
                    } = this.state
                    const enablePrintQR = items.filter(i => !['THANK_CARD', 'BRAND_KIT', 'GIFTBOX_0700NO', 'GIFTCARD_1800NO', 'BOX_0700NO'].includes(i.product_type)).every(o => o.status === "completed")

                    return <div className='ReleaseBasketButton d-inline-flex flex-column' key={itemIndex}>
                        {
                            isShowButtonQC &&
                            <Button
                                type='primary'
                                size='large'
                                className={`${className} mb-1` || ''}
                                onClick={() => this._handleQc(orderData._id, barcode)}
                                disabled={(!!item && !!item.status && item.status === "completed") || (!!batchItem && !!batchItem.status && batchItem.status === "completed")}
                            >
                                QCHT #{numberIndex}
                            </Button>}
                        <Button icon={loading ? 'loading' : 'qrcode'}
                            disabled={!isShowButtonQC ? !enablePrintQR : (!!batchItem && !!batchItem.status && batchItem.status !== "completed")}
                            type='primary'
                            size='large'
                            className={className || ''}
                            onClick={this._handleClickPrintQR(item, itemIndex)}>
                            In QR #{numberIndex}
                        </Button>
                    </div>
                })
            }

            {GIFTBOX_0700NO.length > 0 &&
                GIFTBOX_0700NO.map((item, itemIndex) => {
                    const [_, numberIndex] = `${item.barcode}`.split('_')
                    const {
                        [`loading_${itemIndex}`]: loading
                    } = this.state
                    const enablePrintQR = item.status === 'completed' && items.every(i => i.status === 'completed')

                    return <div className='ReleaseBasketButton' key={itemIndex}>
                        <Button icon={loading ? 'loading' : 'qrcode'}
                            disabled={!enablePrintQR}
                            type='primary'
                            size='large'
                            className={className || ''}
                            onClick={this._handleClickPrintQR(item, itemIndex)}>
                            In QR #{numberIndex}
                        </Button>
                    </div>
                })
            }

            {BOX_0700NO.length > 0 &&
                BOX_0700NO.map((item, itemIndex) => {
                    const [_, numberIndex] = `${item.barcode}`.split('_')
                    const {
                        [`loading_${itemIndex}`]: loading
                    } = this.state
                    const enablePrintQR = item.status === 'completed' && items.every(i => i.status === 'completed')

                    return <div className='ReleaseBasketButton' key={itemIndex}>
                        <Button icon={loading ? 'loading' : 'qrcode'}
                            disabled={!enablePrintQR}
                            type='primary'
                            size='large'
                            className={className || ''}
                            onClick={this._handleClickPrintQR(item, itemIndex)}>
                            In QR #{numberIndex}
                        </Button>
                    </div>
                })
            }

            {
                error && <Alert message={error} type='error' className="mt-4" />
            }
        </>
    }
}

ExportQrCode.propTypes = {
    items: PropTypes.array
}

export default ExportQrCode
